/**
 * CRM microservice routes (`/api/...`, `/cms/...`).
 * See {@link crmBackendUrl} in `src/config/backend.ts` (`CRM_BACKEND_URL`).
 */
import { crmBackendUrl } from './backend';
/** Build CRM URL (`/api/...` relative or absolute against {@link CRM_BACKEND_URL}). */
export function crmApiUrl(pathFromSlash) {
    const rel = pathFromSlash.startsWith('/') ? pathFromSlash : `/${pathFromSlash}`;
    return crmBackendUrl(rel);
}
